module.exports = __webpack_public_path__ + "img/16.fa2c0a7e.png";